
define('eteration/ui/login-viewmodel',['jquery',
        'knockout',
        'eteration/eteration-ajax',
        'eteration/widgets/ui-i18n',
        'eteration/eteration-base',
        'eteration/ui/form-viewmodel',
        'eteration/eteration-i18n',
        'eteration/ui/signup-viewmodel',
		'eteration/widgets/common/ui-force-password-renew',
		'common/recaptcha-constants',
		'ui-helper/gtm-helper',
        'eteration/widgets/ui-recaptcha',
        'eteration/widgets/ui-etrselect',
        'eteration/widgets/ui-dropdownselect',
        'eteration/widgets/ui-keyboard-events',
		'eteration/widgets/common/ui-login-otp',
		'eteration/widgets/ui-recaptcha-enterprise',
        'eteration/ui/validation-helper'],
	function($,ko,etrAjax,ui18,Eteration,FormViewModel,i18n,Signup, forcePassword, recaptchaConstants, gtmUtil) {
	
		function RecaptchaInfo(){
			var self = this;
		    self.privateKey = ko.observable();
		    self.remoteIp = ko.observable();
		    self.challenge = ko.observable();
		    self.response = ko.observable();
		}
	
		function Login(loginCallback, refreshCurrentPage, passengerregistirationLinksForLogin, paymentLinks, loginOperation) {
			
			var self = this;
			ko.utils.extend(self, new FormViewModel.FormViewModel());
			
			self.selectedValue = ko.observable();
			
			self.recaptchaInfo = ko.observable(new RecaptchaInfo());
			self.isCaptchaRequired = ko.observable(false);
			self.isCaptchaRequiredForSecurityQuestion = ko.observable(false);
			
			self.allowedEmailLogin = ko.observable();
			self.allowedTcIdLogin = ko.observable();
			self.allowedMobilePhoneLogin = ko.observable();
			
			self.regionCodes = ko.observableArray();
			self.mobilePhoneNumber = ko.observable();
			self.mobilePhoneCountryCode = ko.observable();
			self.webServiceMessageCode = ko.observable();

			self.email = ko.observable();
			self.isLoginFromHomepage = ko.observable();
			self.isTCCPasswordReset = ko.observable(false);

			self.showWebServiceErrorMessage = ko.observable(false);

			self.validationContextForSigninFormLightbox = ko.jqValidation({postValidators:[]});
			self.validationContextForForgotPasswordLightbox = ko.jqValidation({postValidators:[]});
			self.validationContextForQuestionAnswerLightbox = ko.jqValidation({postValidators:[]});
			self.passengerregistirationLinksForLogin = ko.observable(passengerregistirationLinksForLogin || null);
			self.paymentLinks = ko.observable(paymentLinks || null);

			//OTP
			self.loginOperation = loginOperation;
			self.otpRequiredObject = ko.observable();
			self.showOtp = ko.observable(false);
			self.loginObject = ko.observable();
			self.otpCallBackParams = ko.observable();
			self.otpCallBackStatus = ko.observable(false);
			self.otpResult = ko.observable();

			var regionCodesQuery ={
					app: 'app.ms',
					service:'/parameters/regioncodes',
					disableMSInactiveErrorHandling : true,
					disableLoader: true,
					callback:function(response) {
		    			self.regionCodes.removeAll();
		    			self.regionCodes(response.data);
					}
			};	 
			etrAjax.get(regionCodesQuery);
			
			var allowedLoginTypes = $.jStorage.get("app.miles/miles/allowedlogintypesfromadmin");

			if(!allowedLoginTypes){
				etrAjax.get({
					app: 'app.ms',
					service:'/miles/allowedlogintypesfromadmin',
					disableLoader: true,
					callback:function(response) {
						self.allowedEmailLogin(response.data.allowLoginWithEmail);
						self.allowedMobilePhoneLogin(response.data.allowLoginWithMobilePhone);
						self.allowedTcIdLogin(response.data.allowLoginWithTCId);

						$.jStorage.set("app.miles/miles/allowedlogintypesfromadmin", response.data, {TTL: 3600000});

					}
				});
			}else{
				self.allowedEmailLogin(allowedLoginTypes.allowLoginWithEmail);
				self.allowedMobilePhoneLogin(allowedLoginTypes.allowLoginWithMobilePhone);
				self.allowedTcIdLogin(allowedLoginTypes.allowLoginWithTCId);
			}	

			
			self.clearForm = function() {
				self.loginFields().flyerId("");
				self.loginFields().password("");
			};

			self.passwordMaxLength = ko.observable(6);

			self.loadPasswordMaxLength = function() {
				var passwordLength = $.jStorage.get("/miles/passwordlengthfromadmin");

				if(passwordLength){
					self.passwordMaxLength(parseInt(passwordLength));
				} else {
					etrAjax.get({
						app: 'app.ms',
						service: '/miles/passwordlengthfromadmin',
						disableLoader: true,
						callback: function(response) {
							if(response && response.data){
								self.passwordMaxLength(parseInt(response.data));
								$.jStorage.set("/miles/passwordlengthfromadmin", response.data, {TTL: 3600000});
							}
						}
					});
				}
			}

			self.loadPasswordMaxLength();

			self.loginTypeChange = function () {
				self.clearForm();
				self.otpCallBackStatus(false);
				if (self.loginFields().loginType() === '3') {
					$('.dropdownselect').selectpicker('refresh');
					setTimeout(function() {
						self.initializeInputMask();
					}, 100);
				}
			}


			self.initializeInputMask = function() {
				var phoneNumberInput = $('#username3');
				if (phoneNumberInput.length) {
					var maxLength = phoneNumberInput.attr('maxlength') || 10;
					var maskPattern = '';
					for (var i = 0; i < maxLength; i++) {
						maskPattern += '9';
					}
					phoneNumberInput.inputmask({
						mask: maskPattern,
						placeholder: '_',
						clearMaskOnLostFocus: false,
						showMaskOnHover: false,
						showMaskOnFocus: true,
						clearIncomplete: true,
						definitions: {
							'9': {
								validator: "[0-9]",
								cardinality: 1
							}
						}
					});
				}
			};

			$(document).ready(function() {
				self.initializeInputMask();
			});

			self.isLoginFromHomepage($('#signinModal').attr("data-fromhome"));
			if(!self.isLoginFromHomepage()){
				//WEB-17509 - TCC Responsive kapsaminda anasayfa disindaki girislerde tcc girisi kapatildi.
				$('#corpLoginHeader').hide();
				$('#corpLogin').hide();
			}
			$('#signinModal').on('hidden.bs.modal', function (event) {
				$('#signinModal').attr({"data-fromhome" : "notFromHomepage"});
				$('#signinModal').remove();
				$('.modal-backdrop').remove();
			});


	        self.corporateLoginActive = ko.observable(false);
	        if(!window.corporateLoginRequested) {
				var corporateLoginActive = {
					app: 'app.cc',
		            service:'/corporateclub/corporateLoginActive',
					disableLoader: true,
		            callback:function(response) {

		            	self.corporateLoginActive(response.data);
		            	window.corporateLoginActive = response.data;
		            	window.corporateLoginRequested = true;
		            }
		        }
				etrAjax.get(corporateLoginActive);
	        } else {

	        	self.corporateLoginActive(window.corporateLoginActive);
			}

			self.isLoginWithCorpClub = ko.observable(false);
			self.isLoginWithMS = ko.observable(true);

	        self.loginTriggerCorpClub = function(){
				self.isLoginWithCorpClub(true);
				self.isLoginWithMS(false);
			}

			self.loginTriggerMS = function(){
				self.isLoginWithCorpClub(false);
				self.isLoginWithMS(true);
			}

			self.openSignup = function() {
				$('#signinModal').modal("hide");
				Eteration.loadStaticFragment({
					app:'app.ms',
					module : 'signup',
					el:$('#sigupModalContainer'),
					success : function() {
						$('#signupModal').modal("show");
						ko.applyBindings(new Signup.ViewModel(), $("#sigupModalContainer")[0]);
					}

				});
			};

			self.openPassengerRegistrationSignUpPage = function () {
				open(window.passengerdetailsLinks.msSignupPage, '_blank');
			}

			self.openPaymentSignUpPage = function () {
				open(window.faqsearchLinks.msSignUp, '_blank');
			}

			self.openForgotPasswordPage = function () {
				open(window.faqsearchLinks.forgotpassword, '_blank');
			}

            self.openForgotPasswordTcc = function(_data, e) {
                self.isTCCPasswordReset(true);
                self.forgotPasswordMode(true);

                var $passwordActivateLightbox = $('#ob-passwordActivateLightbox');
                var $signinModal = $('#signinModal');

                $signinModal.modal('hide');

                $signinModal.one('hidden.bs.modal', function() {
                    if ($passwordActivateLightbox.length === 0) {
                        $('<div id="ob-passwordActivateLightbox"></div>')
                            .appendTo('body')
                            .modal('show');
                    } else {
                        $passwordActivateLightbox.modal('show');
                    }
                });
            }

			self.checkWithOutSigninChoice = function(){
				$('#withoutLogin').prop('checked', true);
			}
			
			self.forgotPasswordLightBox = function(){
				
				self.showWebServiceErrorMessage(false);
				var validationResult = self.validationContextForForgotPasswordLightbox.Validate();
                if (validationResult.valid) {
					etrAjax.post({
						app : 'app.ms',
						service : '/miles/resetpinwithemail',
						captchaCheck: true,
						disableErrorHandling : false,
//											largeLoader : true,
//											loaderName : 'select_flights',
						data: { 
				        	'ffid' : $('#ffid-forgotPasswordLightbox').val(),
				        	'email' : $('#email-forgotPasswordLightbox').val()
			        		},
						callback : function(response) {
							
							if(!response.data) {
								return;
							}
							
							self.webServiceMessageCode(response.data.code);
							if(response.data.code != "MS00301400"){
				        		self.showWebServiceErrorMessage(true);
				        	} else {
				        		self.defillInputByGivenId('#ffid-forgotPasswordLightbox');
				        		self.defillInputByGivenId('#email-forgotPasswordLightbox');
				        		$("#ob-forgotPasswordModalLightbox").modal("hide");
				        		
				        		if(!$('#ob-forgotPasswordInfoModalLightbox').length) {
				        			$("#ob-forgotPasswordInfoModalLightbox").appendTo('body').modal("show");
				        		} else {
				        			$("#ob-forgotPasswordInfoModalLightbox").modal("show");
				        		}
				        	}
				        	
							 
						},
					});
                }
			}

			self.validationContext = ko.jqValidation({
				postValidators:[{
					name:"mobileCountryCode",
					id:"mobileCountryCode",//Optional
					func:function() {
					if(!self.regionCodes())
						return i18n.get("ERR-MS-LOGIN-25");
					}
				}]
			});
			
			self.memberloginTcc = function() {
				var validationResult = self.validationContext.Validate();
				if (validationResult.valid) {
					var requestForSignin = {
						app: 'app.cc',
			            service:'/corporateclub/signin',
			            disableErrorHandling : true,
			    		disableLoaderTimeout : true,
						setTokenX: true,
			            data: {
                            'username': self.loginFields().emailtcc(),
                            'loginType': 'tcc',
                            'password': self.loginFields().password()
                        },
			            callback:function(response) {
			            	
					           if(response.type=="SUCCESS"){
					        	   window.location.reload();
					           }
					           else{
					        	   var msg = '';
					        	   if(response.error.messages.length > 0){
					        		   msg = i18n.get(response.error.messages[0].code);
					        	   }else{
					        		   msg = i18n.get('TextField-CAMS-64');
					        	   }
					        	   $('#errorpasswordMsg').html('<small><i class="fa fa-warning red"></i>'+msg+'</small>');
					           }
					           
			            }
			        };
					etrAjax.post(requestForSignin);
				}
			}
			
            self.validationContextForPasswordActivateLightbox = ko.jqValidation({postValidators:[]});
            
            function LoginFields() {
                var self = this;
                self.flyerId = ko.observable(); //"TK002203593"
                self.password = ko.observable(); //pin number
                self.loginType =  ko.observable("1");
                self.emailtcc = ko.observable();
            }
            
            self.loginFields = ko.observable(new LoginFields());
            self.tkNumberVisible = ko.observable(false);
            self.forgotPasswordMode = ko.observable();

			self.passwordActivateSuccessModal = function(){
				$("#passwordActivateSuccessModal").appendTo('body').modal("show");
				self.hidePasswordActivateLightbox();
			}
			self.passwordActivateNotFoundModal = function(){
				$("#passwordActivateNotFoundModal").appendTo('body').modal("show");
				self.hidePasswordActivateLightbox();

			}
			self.hidePasswordActivateLightbox = function() {
				$("#ob-passwordActivateLightbox").modal("hide");
			}
			$("#ob-passwordActivateLightbox").on('hidden.bs.modal', function() {
				$("#ob-passwordActivateLightbox").remove();
			});

			self.passwordActivateResetPin = function(){
				self.showWebServiceErrorMessage(false);
				var validationResult = self.validationContextForPasswordActivateLightbox.Validate();
				if (validationResult.valid) {
					if(!self.isTCCPasswordReset()) {
						etrAjax.post({
							app : 'app.ms',
							service : '/miles/resetpinwithemail',
							disableErrorHandling : false,
							captchaCheck: true,
							data: {
								'ffid' : self.tkNumberVisible() ? $('#ffid-passwordActivateLightbox').val() : '',
								'email' : $('#email-passwordActivateLightbox').val()
							},
							callback : function(response) {
								var msCode =  response.data.code;
								if (msCode == "MS00301400"){
									self.passwordActivateSuccessModal();
								}else if(msCode == "MS00301412"){
									self.passwordActivateNotFoundModal();
								}
								else if(msCode == "MS00301414"){
									self.tkNumberVisible(true);
									self.showWebServiceErrorMessage(true);
									self.webServiceMessageCode(msCode);
								}else {
									self.showWebServiceErrorMessage(true);
									self.webServiceMessageCode(msCode);
								}

							},
						});
					}
					else {
						if(typeof grecaptcha !== 'undefined' && self.isCaptchaRequired()) {
							self.recaptchaInfo().response(grecaptcha.getResponse());
							grecaptcha.reset();
						}
						
						var uiMap = {
							'captchaDivId': 'captchaDivId',
							'email': 'email'
						};
						
						var forgotPasswordDataBlock = { 
								username: self.email(),
								recaptchaInfo: JSON.parse(ko.toJSON(self.recaptchaInfo()))
						};
						
						var requestForForgottenPassword = {
							app: 'app.cc',
							service:'/corporateclub/forgottenpassword',
							uiMap: uiMap,
							data: forgotPasswordDataBlock,
							disableLoader:false,
							callback:function(response) {
								if(response.data){
									self.passwordActivateSuccessModal();
								} else {
									etrAjax.showInfoModal('', ['TextField-CAMS-118']);
								}
							}
						};
						etrAjax.post(requestForForgottenPassword);
						$('#ob-passwordActivateLightbox').remove();
					}
                }
            }

            $(document).on('click', "#clickHereBtn", function(e) {
                self.forgotPasswordMode(false);
                if(!$('#ob-passwordActivateLightbox').length) {
                    $("#ob-passwordActivateLightbox").appendTo('body').modal("show");
                } else {
                	$("#ob-passwordActivateLightbox").modal("show");
                }
                $("#signinModal").appendTo('body').modal("hide");
                e.preventDefault();
                e.stopPropagation();
            });

			recaptchaConstants.addRecaptchaV2();

			function forceChangePinModal(params) {

				$('body').append('<div id="forcepasswordContainer"></div>');
				Eteration.loadStaticFragment({
					app : 'app.ms',
					module : 'forcepassword',
					disableLoader: true,
					el : $("#forcepasswordContainer"),
					success : function() {
						ko.applyBindings( new forcePassword.ViewModel(params), $("#forcepasswordContainer")[0]);
						$("#signin").trigger("click"); // signin modal Closed
						$("#forcePasswordRenewModal").modal("show"); // Forcepin Modal Activated
					}
				});
			}

			self.changePhoneCode = function () {
				var usernameValue = $('#username' + self.loginFields().loginType());
				usernameValue.val("");
				self.updateMobilePhoneMaxLength();
				self.initializeInputMask();
			}

			self.updateMobilePhoneMaxLength = function(){
				var phoneNumberMaxLength;
				if (self.mobilePhoneCountryCode() == 90){
					phoneNumberMaxLength = 10;
					$("#username3").attr("maxlength", phoneNumberMaxLength);
				}
				else{
					phoneNumberMaxLength = 15;
					$("#username3").attr("maxlength", phoneNumberMaxLength);
				}
			};

			self.modalScrollManager = (function() {
				var originalScrollToEl = window.scrollToEl;
				var isScrollDisabled = ko.observable(false);

				return {
					disableScroll: function() {
						if (!isScrollDisabled() && originalScrollToEl) {
							window.scrollToEl = function() {
								return false;
							};
							isScrollDisabled(true);
						}
					},

					enableScroll: function() {
						if (isScrollDisabled() && originalScrollToEl) {
							window.scrollToEl = originalScrollToEl;
							isScrollDisabled(false);
						}
					},

					isScrollDisabled: isScrollDisabled
				};
			})();

			$(document).on('shown.bs.modal', function() {
				self.modalScrollManager.disableScroll();
			});

			$(document).on('hidden.bs.modal', function() {
				self.modalScrollManager.enableScroll();
			});

			//captcha enterprise
			ko.bindingHandlers.captchaEnterprise.addRecaptchaToScript();

			self.memberlogin = function() {
				$('#captchaerror').remove();
				var validationResult = self.validationContextForSigninFormLightbox.Validate();
                if (validationResult.valid) {
                	
                	self.allowPageChangeWithoutClearTerminal();
                	
                	var usernameVal = $('#username' + self.loginFields().loginType()).val();
                	if(self.loginFields().loginType() == '3') {
                		usernameVal = self.mobilePhoneCountryCode() + usernameVal;
                	}
                	
                	if(typeof grecaptcha !== 'undefined' && self.isCaptchaRequired()) 
                	{
                		self.recaptchaInfo().response(grecaptcha.getResponse());
                		grecaptcha.reset();
                	}
					ko.bindingHandlers.captchaEnterprise.validateCaptcha("msloginotp").then(function (token) {

						var recaptchaInfo = JSON.parse(JSON.stringify({response: token}));

						function getOtpCallBackParams() {
							var otpCallBackParamsObj = self.otpCallBackParams();
							if (otpCallBackParamsObj) {
								otpCallBackParamsObj.recaptchaInfo = recaptchaInfo || {};
							}
							return otpCallBackParamsObj || {};
						}


						var data = !self.otpCallBackStatus() ?
							{
								'username': usernameVal,
								'password': $('#lbpassword').val(),
								'loginType': self.loginFields().loginType(),
								'isReqWithRecaptchaEnterprise': true,
								'recaptchaInfo': recaptchaInfo,
								'loginOperation': self.loginOperation
							} : getOtpCallBackParams();

						var loginPost = {
							app: 'app.ms',
							service:'/login/signin',
							disableErrorHandling : true,
							disableLoaderTimeout : true,
							uiMap: {
								'username':'username',
								'password' : 'password',
							},

							setTokenX: true,
							// Login Text, Channel Code, Pin Number
							data: data,
							callback:function(response) {
								$('#errorusername' + self.loginFields().loginType()).html('');
								$('#errormobilePhoneNumber').html('');
								$('#errorpassword').html('');

								if(response.type == "SUCCESS" && response.data && response.data.loggedIn && !response.data.forceChangePinNumber && !response.data.otpRequired) {
									gtmUtil.pushMSLogin(response.data, {page: "", category: ""}, self.loginFields().loginType());
									self.clearForm();
									$('#signinModal').modal("hide");

									if(typeof window.openSelectedPaymentType == 'function'){
										window.openSelectedPaymentType();
									}

									if(loginCallback){
										loginCallback();
										if(refreshCurrentPage){
											location.reload();
										}
									}else{
										if(refreshCurrentPage){
											location.reload();
										}
									}

									var query = window.location.hash;
									if (query && query.indexOf('#login?url=') > -1) {
										var link = window.location.hash.split("#login?url=")[1];
										window.location.hash = "";
										if(link&&link.match(/^https:\/\/.*\.turkishairlines.com/)){
											window.location = link;
										}
										else{
											window.location.reload();
										}

										return false;
									} else if(refreshCurrentPage && window.willReloadAfterLogin) {
										window.location.reload();
									}
									self.isCaptchaRequiredForSecurityQuestion(false);
									self.isCaptchaRequired = ko.observable(false);
									return false;
								} else {
									if ("error" in response) {
										var messages = response.error.validationMessages;
										if (messages && messages.length) {
											var msg;
											var code;
											for (var i = 0; i < messages.length; i++) {
												msg = messages[i].msg;
												code = messages[i].code;
												if (code == "MS00201205" || code == "MS00201210" || code == "MS00201211" || code == "MS00201212") {
													$('#error-messageLightbox').html('<small><i class="fa fa-warning red"></i><span>' + i18n.get(msg) + '</span>&nbsp<span id="clickHereBtn" class="text-decoration-underline cursor-pointer">' + i18n.get("Error-MS-MS000FP") + '</span></small>');
												} else {
													$('#error-messageLightbox').html('<small><i class="fa fa-warning red"></i>' + i18n.get(msg) + '</small>');
												}
											}

											code = messages[0].code;
											msg = messages[0].msg;

											//Error-CAMS-07
											if (code === "Error-CAMS-07" || msg === "Error-CAMS-07") {
												self.isCaptchaRequired(true);
											}

											// there is no security question for this user.
											// so only will show information light box
											if (code === "MS00201221" || msg === "Error-MS-MS00201221") {
												self.webServiceMessageCode(code);
												self.showForgotPasswordInfoModalLightbox();
											}

											// 3 times wrong login attempt
											if (code === "MS00201225" || msg === "Error-MS-MS00201225") {
												self.webServiceMessageCode(code);
												self.isCaptchaRequiredForSecurityQuestion(true);
												self.showSecurityQuestionModalLightbox();
											}

											// pending member
											if (code === "MS00201205" || msg === "Error-MS-MS00201205") {
												self.webServiceMessageCode(code);
												self.isCaptchaRequired(true);
											}

											if (code === "MS00201212" || msg === "Error-MS-MS00201212" || code === "MS00201211" || msg === "Error-MS-MS00201211") {
												self.webServiceMessageCode("Error-MS-MS00201205");
												self.isCaptchaRequired(true);
											}
											//OTP error
											if (code === 'MS009999OTP_INV' || msg === "Error-MS-MS009999OTP_INV") {
												$('#modal-code').modal("hide");
												self.otpResult(response);
											}

											self.otpCallBackStatus(false);

											self.defillInputByGivenId('#password');
										}
									}else {
										if (response.data.otpRequired) {
											var loginData = {
												'username': usernameVal,
												'loginType': self.loginFields().loginType(),
												'password': $('#lbpassword').val(),
												'recaptchaInfo': JSON.parse(ko.toJSON({response: token}))
											}
											self.checkOtpStatus(loginData);
										} else if (response.data.forceChangePinNumber) {
											self.showOtp(false);
											var loginData = !self.otpCallBackStatus() ? {
												'username': usernameVal,
												'loginType': self.loginType(),
												'recaptchaInfo': JSON.parse(ko.toJSON({response: token}))
											}: getOtpCallBackParams();
											forceChangePinModal(loginData);
										}
									}
								}
							},
							complete: function() {
								etrAjax.stopLoading();
							}
						};

						etrAjax.post(loginPost);
					})
                }
			};

			self.otpCallBack = function (params){
				if(params != "RESET"){
					params ? self.otpCallBackStatus(true) : self.otpCallBackStatus(false) ;
					self.otpCallBackParams(params);
					self.memberlogin();
				}else{
					self.otpCallBackStatus(false)
				}
			}

			self.checkOtpStatus = function (loginData) {
				$('#signinModal').modal("hide");
				ko.bindingHandlers.captchaEnterprise.validateCaptcha("msloginotp").then(function (token) {
					var data = {
						"type": "msloginotp",
						"recaptchaInfo": JSON.parse(ko.toJSON({response: token}))
					}
					self.otpRequiredObject({
						"data": data,
						"module": "ms",
						"types": "msloginotp",
						"callback": self.otpCallBack,
						"captchaData": JSON.parse(ko.toJSON({response: token}))
					});

					self.loginObject(loginData);

					self.showOtp(false);
					self.showOtp(true);
					return;
				});

			}

			var updateValidationContextForSigninFormLightbox = function(_newValue){
				self.updateValidationContext("#signinModal",function() { return self.validationContextForSigninFormLightbox });
            };
            
            self.loginFields().loginType.subscribe(updateValidationContextForSigninFormLightbox);
           
			self.showSecurityQuestionModalLightbox = function(){
				$("#securityQuestionAnswerModalLightbox").appendTo('body').modal("show");
				$("#signinModal").appendTo('body').modal("hide");
			}
			
			self.showForgotPasswordInfoModalLightbox = function(){
				$("#ob-forgotPasswordInfoModalLightbox").appendTo('body').modal("show");
				$("#signinModal").appendTo('body').modal("hide");
			}

			self.defillInputByGivenId = function(elementId){
				$(elementId).val("");
			}
			
			self.captchaRequiredControl = function(){
				
				$.ajax({
					url: "/com.thy.web.online.miles/ms/login/iscaptcharequired",
			        type: "GET",
					contentType : "application/json; charset=utf-8",
			        dataType : "json",
			        data: { "loginType" : self.loginFields().loginType() },
			        cache:false,
			        success: function(response) {
			        	self.isCaptchaRequired(response.data);
//	    				3 defa yanlis giris yapildiginda captcha gorunmeyecek,
//	    				signin modali kapatilacak
//	    				"continue without login" isaretlenecek.
			        	if(self.isCaptchaRequired()){	
			        		$('#withoutLogin').prop('checked', true);
		    			}
			        	
			        }
			    });
			};
			
			self.validationContextForQuestionAnswer = ko.jqValidation({postValidators:[]});
			
            self.doResetPin = function () {
            	var msg = i18n.get("Error-CAMS-07");
            	var error = "<div class=\"col-12 nopadding\" id=\"captchaerror\"><small><i class=\"fa fa-warning red\"></i>&nbsp;" + msg + "</small></div>";
                var validationResult = self.validationContextForQuestionAnswerLightbox.Validate();
        		$('#signinCaptcha').next('#captchaerror').remove();
                var elemCaptcha = $(event.target).parents('.modal').find('#signinCaptcha');
                if(typeof grecaptcha !== 'undefined' && self.isCaptchaRequiredForSecurityQuestion()) {
                    var response = grecaptcha.getResponse() || elemCaptcha.find('.g-recaptcha-response').val();
                    self.recaptchaInfo().response(response);	                	
					grecaptcha.reset();
				}
                if (validationResult.valid) {
                    if (self.isCaptchaRequiredForSecurityQuestion() && (self.recaptchaInfo().response() === undefined || self.recaptchaInfo().response() === null || self.recaptchaInfo().response() === "")) {
                    	if($('#signinCaptcha').length) {
                    		showErrorText(error, elemCaptcha);
                    	}
                        self.recaptchaInfo().response("");
                        return;
                    } else {
//					Reset Pin request
                        etrAjax.post({
                            app: 'app.ms',
                            service: '/miles/resetpinwithsecurityquestion',
                            data: {
                                'loginText': 'TK' + $('#username-securityQuestionAnswerLightbox').val(),
                                'loginChannel': "1",
                                'securityAnswer': $('#email-securityQuestionAnswerLightbox').val(),
                                'fromLogin': true,
                                'recaptchaInfo': JSON.parse(ko.toJSON(self.recaptchaInfo()))
                            },
                            callback: function (response) {
                            	if(response.data) {
                                    self.webServiceMessageCode(response.data.code);
                                    $("#securityQuestionAnswerModalLightbox").appendTo('body').modal("hide");
                                    $("#ob-forgotPasswordInfoModalLightbox").appendTo('body').modal("show");
                                    self.defillInputByGivenId('#header-securityQuestionAnswer-input');
                            	} else if(response.error) {
                                    msg = i18n.get(response.error.validationMessages[0].msg);
                                    error = "<div class=\"col-12 nopadding\" id=\"captchaerror\"><small><i class=\"fa fa-warning red\"></i>&nbsp;" + msg + "</small></div>";
                                    showErrorText(error, elemCaptcha);
                            	}
                            },
    						disableErrorHandling: true,
    						preError: function(_e) {
    							showErrorText(error, elemCaptcha);
    						}
                        });
                    }
                } else {
                	showErrorText(error, elemCaptcha);
                }
            }
            
            var showErrorText = function(t, e) {
                if(e.next('#captchaerror').length)
                	e.next('#captchaerror').remove();
            	e.after(t);
			}

		}

		(function() {
			var formUtils = {
				init: function() {
					var self = this;

					$(document).on('focus', 'input.label-selector-input', function(e) {
						self.handleInputFocus(e);
					});

					$(document).on('focusout', 'input.label-selector-input', function(e) {
						self.handleInputFocusOut(e);
					});

					$(document).on('change', '#loginTypeSelect', function() {
						self.handleLoginTypeChange();
					});
				},

				handleInputFocus: function(e) {
					var $input = $(e.target);
					$input.closest('.label-selector').find('label').addClass('active');
					$input.addClass('pb-0');

					if ($input.attr('placeholder')) {
						$input.data('old-placeholder', $input.attr('placeholder'));
					}
					$input.removeAttr('placeholder');
				},

				handleInputFocusOut: function(e) {
					var $input = $(e.target);
					$('#error-messageLightbox').empty();

					if ($input.val() == '') {
						$input.closest('.label-selector').find('label').removeClass('active');
						$input.removeClass('pb-0');
						$input.attr('placeholder', $input.data('old-placeholder'));
					}
				},

				handleLoginTypeChange: function() {
					$(".tk-input-field, #lbpassword").removeClass("has-error");
					$("#errorlbpassword").remove();
				}
			};
			formUtils.init();
		})();

		return { ViewModel:  Login };

});
